import { Button } from '@octopus-do/octopus-storybook'
import cx from 'classnames'
import type React from 'react'
import { forwardRef, useRef, useState } from 'react'

import { Trash } from '../../icons'
import type { Classnames, InputType, Props } from './types'
import css from './UploadFile.module.scss'

const UploadFile: React.ForwardRefExoticComponent<
  React.PropsWithoutRef<Props & InputType> & React.RefAttributes<{}>
> = forwardRef(
  (
    {
      classnames,
      disabled,
      error,
      label,
      size = 'large',
      priority = 'primary',
      onChange,
      ...props
    },
    _ref
  ) => {
    const [value, setValue] = useState<any>(null)
    const [loading, setLoading] = useState(false)
    const inputRef = useRef<HTMLInputElement>(null)

    const classes: Classnames = {
      container: cx(css.container, size && css[size], classnames?.container),
      input: cx(css.input, classnames?.input),
    }

    const onChangeHandle = (e: React.ChangeEvent<HTMLInputElement>) => {
      setLoading(true)
      const file: any = e.target.files?.[0]
      setValue(file)
      onChange?.(file)
      setLoading(false)
    }

    return (
      <div className={classes.container}>
        <div
          className={cx(classes.input, {
            [css.selected]: value,
          })}
        >
          <Button
            className={css.button}
            priority={priority}
            label={label}
            loading={loading}
            disabled={disabled}
            onClick={() => {
              inputRef.current?.click()
            }}
          />
          {loading ? (
            <span className={css.label}>Uploading...</span>
          ) : (
            <span className={css.label}>{value?.name || 'No file'}</span>
          )}
          {value && (
            <div
              className={css.trash}
              onClick={() => {
                setValue(null)
                if (inputRef.current?.value) {
                  inputRef.current.value = ''
                }
              }}
            >
              <Trash size={16} />
            </div>
          )}
          <input
            {...props}
            ref={inputRef}
            type="file"
            onChange={onChangeHandle}
          />

          <div className={css.border} />
        </div>
        {error && <span className={css.error}>{error}</span>}
      </div>
    )
  }
)

export default UploadFile
